import React, { useEffect, useState } from "react";
import { useDebounce } from "../../../../../../Utils/Hooks/useDebounce";

export const BuscadorExistencias = ({ label, placeholder, search, handleSearch }) => {
    const [localSearch, setLocalSearch] = useState(search);

    const debouncedSearch = useDebounce(localSearch, 500);

    useEffect(() => {
        handleSearch(debouncedSearch);
    }, [debouncedSearch]);

    return (
        <div className="d-flex justify-content-between align-items-end flex-wrap mb-3 gap-1rem">
            <div className="formulario-field mb-0" style={{ maxWidth: "220px" }}>
                <label className="text-nowrap">{label}</label>
                <input
                    type="text"
                    className="form-control"
                    placeholder={placeholder}
                    value={localSearch}
                    onChange={(e) => setLocalSearch(e.target.value)}
                />
            </div>
        </div>
    );
};
